
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 3001","d":"M0 0h20v20H0z","fill":"none"}}),_c('path',{attrs:{"data-name":"Pfad 3002","d":"M12.5 10a3.333 3.333 0 10-3.334-3.334A3.332 3.332 0 0012.5 10zM5 8.333v-2.5H3.333v2.5h-2.5V10h2.5v2.5H5V10h2.5V8.333zm7.5 3.333c-2.225 0-6.667 1.117-6.667 3.334v1.667h13.333V15c0-2.217-4.441-3.334-6.666-3.334z","fill":"currentColor"}})])
          )
        }
      }
    